"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var FakeFileUploader = function FakeFileUploader(props) {
  return (0, _preact.h)("div", {
    className: "component-uploader__image-wrapper",
    style: {
      width: props.width,
      display: props.hidden ? 'none' : 'block'
    }
  }, (0, _preact.h)("div", {
    style: {
      paddingBottom: "".concat(props.height / props.width * 100, "%")
    }
  }, (0, _preact.h)("label", {
    className: 'component-uploader__style'
  }, (0, _preact.h)("div", {
    className: 'component-uploader__no-image'
  }, (0, _preact.h)("span", {
    className: 'label-with-icon'
  }, (0, _preact.h)("i", {
    className: 'icon icon-camera component-uploader__icon-camera'
  }), "Click to add")), props.children)));
};

var _default = FakeFileUploader;
exports.default = _default;